/**
 * Slouží k označení tabu na HP, který odkázal na kotvičku
 */
const initTabs = () => {
	window.addEventListener('hashchange', () => {
		const { hash } = window.location;
		const linkEl = document.querySelector(`.HP-nav-link[href='${hash}']`);

		if (!linkEl) {
			return;
		}

		const activeClass = 'is-active';
		const tabs = document.querySelectorAll('.HP-nav-item');

		Array.prototype.slice.call(tabs).forEach((tab) => {
			if (tab.contains(linkEl)) {
				tab.classList.add(activeClass);
			} else {
				tab.classList.remove(activeClass);
			}
		});
	});
};

export default initTabs;
